import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from '@mui/material/styles';
import { QRCodeCanvas } from 'qrcode.react';
import WordBalloon from '../../components/UI/WordBalloon';
import WrapWithHightlight from '@components/UI/WrapWithHightlight';
const StyledContainer = styled('div') `
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  img {
    max-width: 175px;
  }
`;
const StyledText = styled('div') `
  font-weight: 600;
  font-size: 20px;
  color: #2e2e2e;
  line-height: 1.2;
`;
const StyledDescription = styled('p') `
  line-height: 1.4;
  font-size: 14px;
  margin: 0;
`;
const StyledImageContainer = styled('div') `
  display: flex;
  gap: 24px;
  img {
    height: 40px;
  }
`;
const DownloadMobileApp = ({ 'data-testid': dataTestId = 'download-mobile-app', title = 'Download the Repeat Mobile App', description = 'This feature is only available on your mobile device using the official Repeat mobile app. Available now.', }) => {
    var _a;
    const appStoreUrl = process.env.APP_DOWNLOAD_APP_STORE_URL;
    const playStoreUrl = process.env.APP_DOWNLOAD_GOOGLE_PLAY_URL;
    const universalUrl = (_a = process.env.APP_DOWNLOAD_UNIVERSAL_URL) !== null && _a !== void 0 ? _a : 'https://www.repeat.gg';
    const theme = useTheme();
    return (_jsxs(StyledContainer, { "data-testid": dataTestId, children: [_jsx(WordBalloon, { text: 'Scan QR code & download the app' }), _jsx(WrapWithHightlight, { color: theme.palette.primary.main, children: _jsx(QRCodeCanvas, { fgColor: theme.palette.primary.main, value: universalUrl, size: 134 }) }), _jsx(StyledText, { children: title }), description && _jsx(StyledDescription, { children: description }), _jsxs(StyledImageContainer, { children: [_jsx("a", { href: appStoreUrl, target: "_blank", rel: "noreferrer", children: _jsx("img", { src: "/img/apple-store-download.png", alt: "Download on the App Store" }) }), _jsx("a", { href: playStoreUrl, target: "_blank", rel: "noreferrer", children: _jsx("img", { src: "/img/google-play-download.png", alt: "Get it on Google Play" }) })] })] }));
};
export default DownloadMobileApp;
